import React from "react";

const Advertisements = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        I.
        <span className="text-[#01A7D1] "> ADVERTISEMENTS</span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Aspects of the Platform and other Yostel services may be supported by
        advertising revenue. As such, Yostel may display advertisements and
        promotions on the service. The manner, mode and extent of advertising by
        Yostel on the Platform are subject to change and the appearance of
        advertisements on the Platform does not necessarily imply endorsement by
        Yostel of any advertised products or services. You agree that Yostel
        shall not be responsible or liable for any loss or damage of any sort
        incurred by you as a result of any such dealings or as the result of the
        presence of such advertisers on the Platform.
      </p>
    </div>
  );
};

export default Advertisements;
